import React, { useState, useRef, useEffect } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addStock, scanProduct, vendorList, uploadInvoice } from "../publicationSlice";
import { containsNumber, validateValueWithoutSpace, length_Thirteen, validateIsFileImageType, image_size_5MB } from "../../../Utils/validators";
import moment from "moment";
import barCode from "../../../Assets/Images/icons/barcode.png";
import DeleteIcon from "@mui/icons-material/Delete";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import DateTimePicker from "../../../Component/dateTimePicker";
import { useDebounce } from "../../../Hooks/useDebounce";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import DropdownWithClear from "../../../Component/dropdownWithClear";

import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const StockIn = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement>(null);
  const initialStock = {
    _id: "",
    name: "",
    price: "",
    image: "",
    uniqueNo: "",
    quantity: 0,
    newQuantity: 0,
  };

  const [state, setState] = useState<{
    productQuantity: any;
    barcode: any;
    startDate: any;
    stockData: typeof initialStock[];
    printerList: { _id: string; name: string }[];
    printerName: any;
    totalAmount: any;
    invoiceLink: any;
    selectedInvoice: any;
  }>({
    productQuantity: 0,
    barcode: "",
    startDate: moment
      .utc(new Date())
      .utcOffset(330)
      .format("YYYY-MM-DD HH:mm:ss"),
    stockData: [initialStock],
    printerList: [],
    printerName: "",
    totalAmount: "",
    invoiceLink: "",
    selectedInvoice: "",
  });
  const updateState = (key: any) => {
    setState((prev) => ({ ...prev, ...key }));
  };
  const debouncedValue = useDebounce(state?.barcode, 300);
  const [mediaFiles, setMediaFiles] = useState<any>();

  useEffect(() => {
    if (debouncedValue && debouncedValue?.length > 12) {
      const existingStock = state?.stockData?.find(
        (item) => item?.uniqueNo === debouncedValue
      );
      if (existingStock) {
        // dispatch(showErrorSnackbar("Stock already exists"));
        setState((prevState) => ({
          ...prevState,
          barcode: "",
        }));
      } else {
        dispatch(
          scanProduct({
            id: debouncedValue,
            callback: (res: any) => {
              if (res?.data) {
                let newArr = JSON.parse(JSON.stringify(state?.stockData));
                const initialStockIndex = newArr.findIndex(
                  (item: any) => !item._id && !item.uniqueNo
                );
                let initialStockObj = null;
                if (initialStockIndex !== -1) {
                  initialStockObj = newArr.splice(initialStockIndex, 1)[0]; // Remove and store it
                }
                // res?.data ?.forEach((item:any) => {
                const findData = res?.data?.stock?.find(
                  (stockItem: any) => stockItem?.location === "twobrothers-inhouse"
                );

                const isAlreadyPresent = newArr.some(
                  (existingItem: any) => existingItem?.uniqueNo === res?.data?.uniqueNo
                );

                if (!isAlreadyPresent) {
                  newArr.push({
                    _id: res?.data?._id,
                    price: res?.data?.offerPrice,
                    quantity: findData?.quantity
                      ? findData?.quantity
                      : 0,
                    name: res?.data?.name,
                    image: res?.data?.image,
                    uniqueNo: res?.data?.uniqueNo,
                    newQuantity: 0,
                  });
                }
                // });

                if (initialStockObj) {
                  newArr.push(initialStockObj);
                } else {
                  newArr.push({ ...initialStock });
                }
                setState((prevState) => ({
                  ...prevState,
                  stockData: newArr,
                  barcode: "",
                }));
              } else {
                // dispatch(showErrorSnackbar("No book found with this number"));
              }


            },
            errorCallback: () => { },
          })
        );
      }
    };
    dispatch(
      vendorList({
        callback: (res: any) => {
          const newList = res?.data?.map((item: any) => {
            return { _id: item?._id, name: item?.companyName };
          });
          setState((prevState) => ({
            ...prevState,
            printerList: res?.data?.length > 0 ? newList : [],
          }));
        },
        errorCallback: () => { },
      })
    );
  }, [debouncedValue, state?.startDate]);

  const validateArr = () => {
    let disable = false;
    state?.stockData
      ?.filter((item) => item?._id !== "")
      .forEach((itm) => {
        if (Number(itm?.newQuantity) <= 0) disable = true;
      });
    return disable;
  };
  const handleChange = (value: any, index: number) => {
    const newArr = JSON.parse(JSON.stringify(state?.stockData));
    if (value !== "") {
      if (!containsNumber(value)) {
        // dispatch(showErrorSnackbar("Only Numbers are allowed!"));
        return;
      } else if (!validateValueWithoutSpace(value)) {
        // dispatch(showErrorSnackbar(validateIsNumberOnlyErrMsg));
        return;
      } else {
        newArr[index].newQuantity = value;
        updateState({ stockData: newArr });
      }
    }
    newArr[index].newQuantity = value;
    updateState({ stockData: newArr });
    calculateQuantity(newArr);
    calculateTotalPrice(newArr);
  };

  const validations = () => {
    const checkStockData = state?.stockData?.filter((item) => item?._id !== "");
    return (
      state?.printerName === "" ||
      state?.totalAmount === "" ||
      state?.startDate === "" ||
      checkStockData?.length === 0 ||
      mediaFiles === undefined ||
      mediaFiles === "" ||
      validateArr()
    );
  };
  const handleDelete = (index: any) => {
    const newArr = [...state?.stockData];
    if (index > -1) {
      newArr.splice(index, 1);
    }
    setState((prevState) => ({
      ...prevState,
      stockData: newArr,
    }));
    calculateQuantity(newArr);
    calculateTotalPrice(newArr);
  };
  const calculateQuantity = (newArr: any) => {
    const num = newArr
      ?.filter((item: any) => item?._id !== "")
      .reduce((acc: any, curr: any) => {
        return (acc += Number(curr?.newQuantity));
      }, 0);
    updateState({ productQuantity: num });
  };
  const calculateTotalPrice = (newArr: any) => {
    const sum = newArr
      ?.filter((item: any) => item?._id !== "")
      .reduce((acc: any, curr: any) => {
        return (acc += Number(curr?.newQuantity * curr?.price));
      }, 0);
    updateState({ totalAmount: sum });
  };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      barcode: "",
    }));
  };
  const focusBarcodeInput = (e?: any) => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  useEffect(() => {
    focusBarcodeInput();
  }, []);
  const handelClick = () => {
    focusBarcodeInput();
  };
  const handleChangeBarcode = (e: any) => {
    setState((prevState) => ({
      ...prevState,
      barcode: e.target.value.toUpperCase(),
    }));
  };

  const handleChangeInvoice = (e: any) => {
    e.preventDefault();
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    // e.preventDefault();
    // if (!validateIsFileImageType(e)) {
    //   // dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
    //   return;
    // }
    // if (e.target.files[0]?.size > image_size_5MB) {
    //   // dispatch(showErrorSnackbar("Image size should be less than 5 MB!!!"));
    // } else {
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!mediaTypes.includes(file.type)) {
      console.error("Unsupported file type:", file.type);
      return;
    }
    reader.onloadend = () => {
      setMediaFiles(file);
      setState((prevState) => ({
        ...prevState,
        selectedInvoice: reader.result,
      }));
    };
    reader.readAsDataURL(file);
    // }
  };
  const onAddStock = (invoiceLink: any) => {
    if (invoiceLink) {
      const {
        productQuantity,
        printerName,
        totalAmount,
        startDate,
        stockData,
        selectedInvoice
      } = state;
      const newProductArr = stockData
        ?.filter((item) => item?._id !== "")
        ?.map((item) => {
          return {
            productId: item?._id,
            quantity: Number(item?.newQuantity),
          };
        });
      const reqBody = {
        totalCount: productQuantity,
        venderId: printerName?._id,
        totalAmount: totalAmount,
        addedDate: startDate,
        status: 1,
        file: invoiceLink,
        products: newProductArr,
      };
      if (invoiceLink) reqBody.file = invoiceLink;
      dispatch(
        addStock({
          params: reqBody,
          callback: (res: any) => {
            setState((prevState) => ({
              ...prevState,
              stockData: [initialStock],
              barcode: "",
              newQuantity: 0,
              printerName: "",
              totalAmount: "",
              invoiceLink: "",
              selectedInvoice: "",
            }));
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          },
        })
      );
    };
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (mediaFiles) {
      dispatch(
        uploadInvoice({
          params: mediaFiles,
          callback: (res: any) => {
            if (res?.status === "success") {
              onAddStock(res?.data?.name);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
            setTimeout(() => dispatch(hideSnackbar()), 5000);
          },
        })
      );
    } else {
      dispatch(showSnackbar({ message: "Please upload invoice", type: "error" }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    }
  };
  const renderTable = () => {
    return (
      <div className="admin-table table-responsive">
        <table className="table table-striped table-hover align-middle text-md-start text-center">
          <thead>
            <tr>
              <th>Product Image</th>
              <th>Product Name</th>
              <th>Price</th>
              <th>Old Quantity</th>
              <th>New Quantity</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {state?.stockData?.map((item, index) => {
              if (item?._id) {
                return (
                  <tr key={index}>
                    <td>
                      <img
                        src={item?.image}
                        alt="coverImage"
                        style={{ height: "50px", width: "60px" }}
                      />
                    </td>
                    <td className="col-md-3">{item?.name}</td>
                    <td>
                      <InputField
                        placeholder={"₹"}
                        disabled
                        value={item?.price}
                      />
                    </td>
                    <td>
                      <InputField
                        placeholder={"₹"}
                        disabled
                        value={item?.quantity}
                      />
                    </td>
                    <td>
                      <InputField
                        placeholder={"Enter Quantity"}
                        value={item?.newQuantity}
                        setInputText={(val: any) => handleChange(val, index)}
                      />
                    </td>
                    <td>
                      <ClearOutlinedIcon
                        className="colorPurple cursor"
                        fontSize="small"
                        onClick={() => {
                          handleDelete(index);
                        }}
                      />
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr className="d-flex my-3">
                    <input
                      type="text"
                      className="form-control w-50"
                      ref={inputRef}
                      value={state?.barcode}
                      placeholder=""
                      maxLength={length_Thirteen - 1}
                      onChange={handleChangeBarcode}
                    />
                    <span className="text-dark d-flex">
                      <DeleteIcon
                        className="cursor"
                        color="error"
                        fontSize="small"
                        onClick={() => handleClose()}
                      />
                    </span>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Stock In"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="col-md-3 mb-3">
          <LabelInput labelName={"Scan QR Code"} />
          <div className="bxshadow p-2 borderRadius text-center cursor col-3" onClick={handelClick}>
            <img src={barCode} alt="QR Code" width={30} />
          </div>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderTable()}
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          <div>
            {/* <div className="row d-flex justify-content-between bxshadow  p-3"> */}
            <form onSubmit={handleSubmit}>
              <div className=" d-flex justify-content-equal p-3">
                <div className="row">
                  <div className="col-md-4 d-flex align-items-center">
                    <div className="col-md-4">
                      <LabelInput labelName={"Total Quantity"} /></div>
                    <div className="col-md-8">
                      <InputField
                        placeholder={"Total Quantity"}
                        value={state?.productQuantity}
                        disabled
                      />
                    </div>
                  </div>
                  <div className=" col-md-4 d-flex align-items-center pt-2">
                    <div className="col-md-4">
                      <LabelInput labelName={"Printer Name"} /></div>
                    <div className="col-md-8">
                      <DropdownWithClear
                        labelName={"Printer Name"}
                        setInputText={(value: any) =>
                          setState((prevState) => ({
                            ...prevState,
                            printerName: value,
                          }))
                        }
                        options={state?.printerList}
                        value={state?.printerName}
                      /></div>
                  </div>
                  <div className="col-md-4 d-flex align-items-center pt-2">
                    <div className="col-md-4">
                      <LabelInput labelName={"Total Amount"} /></div>
                    <div className="col-md-8">
                      <InputField
                        placeholder="Total Amount"
                        value={state?.totalAmount}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4 d-flex align-items-center justify-content-start pt-2">
                    <div className="col-md-4">
                      <LabelInput labelName={"Invoice Image"} />
                    </div>
                    <ImagePickerAndViewer
                      value={state?.selectedInvoice}
                      handleChange={(e: any) => handleChangeInvoice(e)}
                      htmlFor={"pdf-upload-1"}
                      doctype={"pdf/image"} />
                  </div>
                  <div className="col-md-4 d-flex align-items-center justify-content-start pt-2">
                    <div className="col-md-4">
                      <LabelInput labelName={"Date"} />
                    </div>
                    <div className="col-md-8">
                      <DateTimePicker
                        value={state?.startDate}
                        setInputText={(value: any) =>
                          setState((prevState) => ({
                            ...prevState,
                            startDate: value,
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <div className="col-md-3 d-flex justify-content-center">
                      <Submitbtn
                        name={"Save and Update Stock"}
                        disabled={validations()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockIn;
